import Vue from 'vue';
import Router from 'vue-router';
import routes from './routes';
import store from '@/store';
import Auth from '@/api/auth.js';

import {
    AUTH_LOGIN_URL
} from '@/constants/auth.js';

Vue.use(Router);

let router = new Router({
    base: '/',
    mode: 'history',
    routes
});

router.beforeEach((to, from, next) => {
    // Update loading within vuex to access where needed
    store.dispatch('updateLoading', true);

    // Run authenticated to check if route can be continued
    Auth.authenticated()
        .then(response => {
            if(response.success === true && response.fetch === true) {
                // Success is available but user data neededs fetching
                return Auth.me();
            } else if(response.success === false) {
                // Success is not available provide with reject
                return Promise.reject(response);
            }
        }).then(response => {
            // Successfully able to continue with route if authenticated redirect is not set
            if(to.matched.some(record => record.meta.authenticatedRedirect)) {
                next({
                    path: to.meta.authenticatedRedirect
                });
            } else {
                next();
            }
            return;
        }).catch(response => {
            // Caught error redirect back to login if auth middleware is set
            if(to.matched.some(record => record.meta.auth)) {
                next({
                    path: AUTH_LOGIN_URL
                });

                // Update Loading within vuex incase redirection back to same page
                store.dispatch('updateLoading', false);
            } else {
                next();
            }

            return;
        });
});

router.afterEach((to, from, next) => {
    store.dispatch('updateLoading', false);
});

export default router;


// WEBPACK FOOTER //
// ./src/router/index.js